import { render, staticRenderFns } from "./TeamsOverview.vue?vue&type=template&id=117ddf9a&scoped=true"
import script from "./TeamsOverview.vue?vue&type=script&lang=js"
export * from "./TeamsOverview.vue?vue&type=script&lang=js"
import style0 from "./TeamsOverview.vue?vue&type=style&index=0&id=117ddf9a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "117ddf9a",
  null
  
)

export default component.exports